import { RUTAS } from 'const/Rutas';
import { useState } from 'react';
import chatServices from 'services/chat';

export const useReunion = () => {
  const [isCreandoReunion, setIsCreandoReunion] = useState(false);
  const handleCrearReunion = async data => {
    setIsCreandoReunion(true);
    let requestParams = { origenSalaChat: data.origenSalaChat };

    try {
      if (
        Object.hasOwn(data, 'origenSalaChat') &&
        data.origenSalaChat === 'empresa'
      ) {
        requestParams.empresa = {
          codigoEmpresa: data.codigoEmpresa
        };
      }

      if (Object.hasOwn(data, 'codigoSucursalAdministrada')) {
        requestParams.sucursal = {
          codigoSucursal: data.codigoSucursalAdministrada
        };
      }
      if (Object.hasOwn(data, 'codigoResiduo')) {
        requestParams.residuo = {
          codigoResiduo: data.codigoResiduo
        };
      }

      const response = await chatServices.crearSalaChat(requestParams);

      if (response.status === 200 && !response.data.error) {
        if (response.data.error) {
          return;
        }

        window.open(`${RUTAS.CHAT}/${response.data.codigoSalaChat}`, '_blank');
      }
    } catch (error) {
      console.log('ERROR_AL_CREAR_REUNION ', error);
    } finally {
      setIsCreandoReunion(false);
      return false;
    }
  };

  return {
    isCreandoReunion,
    handleCrearReunion
  };
};
